module.exports = __webpack_public_path__ + "img/rejdops.e007c7ae.svg";